// PdfThumbnail.js
import React, { useEffect, useRef } from 'react';
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist/legacy/build/pdf';
import worker from 'pdfjs-dist/legacy/build/pdf.worker.entry';

GlobalWorkerOptions.workerSrc = worker;

const PdfThumbnail = ({ file }) => {
  const canvasRef = useRef();

  useEffect(() => {
    const renderThumbnail = async () => {
      let fileBlob;

      if (typeof file === 'string') {
        // Fetch the remote file
        const response = await fetch(file);
        fileBlob = await response.blob();
      } else if (file instanceof File || file instanceof Blob) {
        fileBlob = file;
      } else {
        console.error('Unsupported file type:', file);
        return;
      }

      const arrayBuffer = await fileBlob.arrayBuffer();
      const pdf = await getDocument({ data: arrayBuffer }).promise;
      const page = await pdf.getPage(1);

      const viewport = page.getViewport({ scale: 0.5 });
      const canvas = canvasRef.current;
      const context = canvas.getContext('2d');

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      await page.render({
        canvasContext: context,
        viewport,
      }).promise;
    };

    if (file) {
      renderThumbnail().catch(err => console.error('Error rendering thumbnail:', err));
    }
  }, [file]);

  return (
    <canvas
      ref={canvasRef}
      style={{ width: '80px', height: '120px', borderRadius: '8px', border: '1px solid #ccc' }}
    />
  );
};

export default PdfThumbnail;
